var _rect, _ellipse, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoPerson(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 177,
    height: 264,
    viewBox: "0 0 177 264",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 177,
    height: 264,
    rx: 5,
    fill: "#C4C4C4"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 89.3341,
    cy: 120.334,
    rx: 14.3341,
    ry: 14.3341,
    stroke: "#E2E2E2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66 154.048C65.9962 153.04 66.2216 152.045 66.6591 151.137C68.0321 148.391 71.9039 146.936 75.1168 146.277C77.4338 145.782 79.7829 145.452 82.1465 145.288C86.5225 144.904 90.9238 144.904 95.2998 145.288C97.6632 145.454 100.012 145.784 102.33 146.277C105.542 146.936 109.414 148.254 110.787 151.137C111.667 152.988 111.667 155.136 110.787 156.986C109.414 159.87 105.542 161.188 102.33 161.819C100.015 162.334 97.6653 162.674 95.2998 162.835C91.7381 163.137 88.1598 163.192 84.5904 163C83.7666 163 82.9703 163 82.1465 162.835C79.7899 162.676 77.449 162.336 75.1442 161.819C71.9039 161.188 68.0595 159.87 66.6591 156.986C66.2238 156.068 65.9987 155.064 66 154.048Z",
    stroke: "#E2E2E2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoPerson);
export default __webpack_public_path__ + "static/media/no-person.6f8840d1fafc0af3553219db84e45127.svg";
export { ForwardRef as ReactComponent };